import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["title", "children"],
  _excluded2 = ["label", "children"];
import PropTypes from 'prop-types';
import React, { Fragment, forwardRef, useState } from 'react';
import Button from "@mui/material/Button/Button.js";
import Menu from "@mui/material/Menu/Menu.js";
import Tooltip from "@mui/material/Tooltip/Tooltip.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A button component for the NavBar menu
 */
export var NavButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var title = _ref.title,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: title || '',
    placement: "bottom",
    children: /*#__PURE__*/_jsx(Button, _extends({
      sx: {
        '&:not(:first-of-type)': {
          ml: 1
        },
        width: 34,
        height: 34,
        minWidth: 34
      },
      color: "inherit",
      size: "small",
      ref: ref
    }, props, {
      children: children
    }))
  });
});
NavButton.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
};
var NavMenuButton = function NavMenuButton(_ref2) {
  var label = _ref2.label,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var menuItems = React.Children.toArray(children).map(function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      onClick: function onClick(event) {
        handleClose(event);
        if (child.props.onClick) {
          child.props.onClick();
        }
      }
    });
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(NavButton, _extends({
      onClick: handleClick
    }, props, {
      children: label
    })), /*#__PURE__*/_jsx(Menu, {
      sx: {
        '& .MuiMenu-paper': {
          minWidth: 200
        }
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      anchorEl: anchorEl,
      open: Boolean(anchorEl),
      onClose: handleClose,
      keepMounted: true,
      children: menuItems
    })]
  });
};
export default NavMenuButton;